import type { SVGProps } from 'react';
import * as React from 'react';

const SvgChevronRight16 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6.667 12 4-4-4-4"
    />
  </svg>
);
export default SvgChevronRight16;
